<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="data-sample flex-column flex-justify-start flex-align-start">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备类型：</div>
          <el-select v-model="mainpage.form.devtype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.devtype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="mainpage.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="mainpage.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="mainpage.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">抄表方式：</div>
          <el-select v-model="mainpage.form.paratype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.paratype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="mainpage.startTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="mainpage.endTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称：</div>
          <el-input v-model="mainpage.form.sn" placeholder="设备名称" style="width: 250px"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="hadleMeterSearch">查询</el-button>
          <el-button type="success" icon="el-icon-upload" style="font-size: 14px; padding: 11px;" @click="hadleExport">打印</el-button>
        </div>
      </div>
      <div class="data-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-start flex-align-start">
          <el-table :data="mainpage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="devtype" label="设备类型"></el-table-column>
            <el-table-column prop="value" label="表具数值"></el-table-column>
            <el-table-column prop="location" label="安装位置" width="300"></el-table-column>
            <el-table-column prop="datetime" label="更新时间"></el-table-column>
            <el-table-column prop="paratype" label="录入方式"></el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="mainpage.form.totalpage"
            :current-page.sync="mainpage.form.currpage"
            :page-size="mainpage.form.pagesize"
            @current-change="handleMainPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ExcelJS from 'exceljs'
import saveAs from 'file-saver'
import {getChangqu, getLouhao, getLouCeng, getHistoryList} from '@/api/engery.js'
export default {
  name: 'EngeryHistory',
  data() {
    return {
      mainpage: {
        form: {
          devtype: '全部',
          changqu: '全部',
          louhao: '',
          louceng: '',
          paratype: '',
          startTime: '',
          endTime: '',
          sn: '',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        startTime: null,
        endTime: null,
        tableData: [],
        options: {
          devtype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
          changqu: [],
          louhao: [],
          louceng: [],
          paratype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '自动上传',
              label: '自动上传'
            },
            {
              value: '手工抄表',
              label: '手工抄表'
            }
          ]
        }
      }
    }
  },
  async mounted() {
    const changqulist = await getChangqu()
    this.mainpage.options.changqu = changqulist.data
    const historyList = await getHistoryList(this.mainpage.form)
    this.mainpage.tableData = historyList.data
    this.mainpage.form.totalpage = historyList.totalpage
  },
  methods: {
    async handleMainPage(value) {
      await this.hadleMeterSearch()
    },
    formatDateTime(now, sign) {
      const padZero = n => n < 10 ? `0${n}` : n
      let year = now.getFullYear()
      let month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      if(sign == 1) {
        month = padZero(month - 1)
        if(month == 0) {
          year -= 1
          month = 12
        }
      }
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    async hadleMeterSearch() {
      if(this.mainpage.startTime != null) {
        const startTime = this.formatDateTime(this.mainpage.startTime, 0)
        this.mainpage.form.startTime = startTime.substr(0, 10)
      }
      if(this.mainpage.endTime != null) {
        const endTime = this.formatDateTime(this.mainpage.endTime, 0)
        this.mainpage.form.endTime = endTime.substr(0, 10)
      }
      const historyList = await getHistoryList(this.mainpage.form)
      this.mainpage.tableData = historyList.data
      this.mainpage.form.totalpage = historyList.totalpage
    },
    hadleExport() {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('历史查询')
      sheet.addRow(['序号', '设备编号', '设备名称', '设备类型', '表具数值', '安装位置', '更新时间', '录入方式']).font = { bold: true }
      for(var i = 0;i < this.mainpage.tableData.length;i++) {
        let temp = []
        temp.push(this.mainpage.tableData[i].id)
        temp.push(this.mainpage.tableData[i].sn)
        temp.push(this.mainpage.tableData[i].name)
        temp.push(this.mainpage.tableData[i].devtype)
        temp.push(this.mainpage.tableData[i].value)
        temp.push(this.mainpage.tableData[i].location)
        temp.push(this.mainpage.tableData[i].datetime)
        temp.push(this.mainpage.tableData[i].paratype)
        sheet.addRow(temp)
      }
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const datetime = this.formatDateTime(new Date()).replace(/[\s:-]/g, '')
        const fileName = '历史查询' + datetime + '.xlsx'
        saveAs(blob, fileName)
      })
    },
    async handleChangqu(value) {
      this.mainpage.form.louhao = ''
      this.mainpage.louhao = []
      this.mainpage.form.louceng = ''
      this.mainpage.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouhao(result[0].park_id)
      if(response.data.length <= 1) {
        return
      }
      this.mainpage.options.louhao = response.data
      if(this.mainpage.options.louhao.length > 0) {
        this.mainpage.form.louhao = this.mainpage.options.louhao[0].value
      }
    },
    async handleLouhao(value) {
      this.mainpage.form.louceng = ''
      this.mainpage.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouCeng(result[0].building_id)
      if(response.data.length <= 1) {
        return
      }
      this.mainpage.options.louceng = response.data
      if(this.mainpage.options.louceng.length > 0) {
        this.mainpage.form.louceng = this.mainpage.options.louceng[0].value
      }
    },
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.data-sample {
  width: 99%;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.data-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.data-page {
  width: 98%;
}
</style>
